import { gql } from '@apollo/client';

export const CREATE_PAYMENT_INTENT = gql`
  mutation CreatePaymentIntent($input: CreatePaymentIntentInput!) {
    createPaymentIntent(input: $input) {
      clientSecret
      paymentIntentId
      amount
      currency
      status
      checkoutUrl
    }
  }
`;

export const CONFIRM_PAYMENT = gql`
  mutation ConfirmPayment($input: ConfirmPaymentInput!) {
    confirmPayment(input: $input) {
      success
      subscriptionIds
      transactionId
      accessExpiresAt
      message
    }
  }
`;

export const GET_PAYMENT_STATUS = gql`
  query GetPaymentStatus($paymentIntentId: String!) {
    getPaymentStatus(paymentIntentId: $paymentIntentId) {
      paymentIntentId
      status
      clientSecret
    }
  }
`;

export const CANCEL_PAYMENT_INTENT = gql`
  mutation CancelPaymentIntent($paymentIntentId: String!) {
    cancelPaymentIntent(paymentIntentId: $paymentIntentId)
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = gql`
  mutation CreateBillingPortalSession {
    createBillingPortalSession {
      url
    }
  }
`;

export const HANDLE_CHECKOUT_SESSION_COMPLETED = gql`
  mutation HandleCheckoutSessionCompleted($sessionId: String!) {
    handleCheckoutSessionCompleted(sessionId: $sessionId) {
      success
      subscriptionIds
      transactionId
      accessExpiresAt
      message
    }
  }
`;